import React, {useEffect, useState} from 'react';
import {Form, Input} from 'antd';
import Button from "../../common/Button/Button";

import './styles.scss';

import {ALLOWED_ROLES_BY_ROLE, UsersInviteTypes} from "./Users.invite.types";
import cx from "classnames";
import {ArrowRightOutlined, BankOutlined, UserOutlined} from '@ant-design/icons';
import {ROLES} from "../../../settings";
import useUserStore from "../../../data/User.store";
import GeographicalStatesSelect from "../../common/Select.geographicalStates.tsx/Select.geographicalStates";
import FormSectionHeader from "../../common/FormSectionHeader/FormSectionHeader";
import UserRoleSelect from "../User.roles.select/User.roles.select";

interface Props {
    onSubmit: (values: any) => void
    applyDrawerStyles?: boolean,
}

function UsersInviteForm(props: Props) {
    const {onSubmit, applyDrawerStyles} = props;
    const {user} = useUserStore();
    const [form] = Form.useForm();
    // eslint-disable-next-line
    const [valuesForm, setValuesForm] = useState({});
    const [submittingForm, setSubmittingForm] = useState(false);


    useEffect(() => {

    }, [])


    async function onSubmitClick() {
        if (submittingForm) return false;
        setSubmittingForm(true);
        try {
            let valid = await form.validateFields();
            if (!valid.errorFields && onSubmit) {
                let values = form.getFieldsValue();
                await onSubmit(values);
                form.resetFields();
            }
        } catch (e) {

        }
        setSubmittingForm(false);
    }

    function onValuesChange(v) {
        setValuesForm(v)
    }

    function renderButton() {
        if (applyDrawerStyles) {
            return (
                <div className='form-stickied-footer'>
                    <Button onClick={onSubmitClick} htmlType='submit' loading={submittingForm}
                            icon={<ArrowRightOutlined/>} iconPosition='right'>
                        Invite User
                    </Button>
                </div>
            )
        } else {
            return (
                <Button onClick={onSubmitClick} htmlType='submit' loading={submittingForm}>
                    Invite User
                </Button>
            )
        }
    }

    function getRolesToShow() {
        if (user?.role?.name) {
            return ALLOWED_ROLES_BY_ROLE[user.role.name];
        }
    }

    let rolesToShow = getRolesToShow();
    let initialValues = {
        [UsersInviteTypes.Role]: ROLES.CLIENT,
    }

    return (
        <Form className={cx('invite-user-form', {'as-drawer': applyDrawerStyles})} name="invite-user-form"
              layout='vertical' form={form}
              onFinish={onSubmitClick} autoComplete="off" preserve={false} onValuesChange={onValuesChange}
              requiredMark='optional' initialValues={initialValues}>
            <div className='invite-user-form-content'>
                <FormSectionHeader text='User Information' icon={<UserOutlined/>}
                                   help="All of the information on the user themselves."/>
                <Form.Item label='Email' name={UsersInviteTypes.Email}
                           rules={[{required: true, message: 'This field is required.'}]}>
                    <Input size='large'/>
                </Form.Item>
                <Form.Item label='First Name' name={UsersInviteTypes.FirstName}
                           rules={[{required: true, message: 'This field is required.'}]}>
                    <Input size='large'/>
                </Form.Item>
                <Form.Item label='Last Name' name={UsersInviteTypes.LastName}
                           rules={[{required: true, message: 'This field is required.'}]}>
                    <Input size='large'/>
                </Form.Item>
                {rolesToShow &&
                <Form.Item label='Role' name={UsersInviteTypes.Role}
                           rules={[{required: true, message: 'This field is required.'}]}>
                    <UserRoleSelect roles={rolesToShow}/>
                </Form.Item>}

                {(form.getFieldValue(UsersInviteTypes.Role) === ROLES.CLIENT || !form.getFieldValue(UsersInviteTypes.Role)) &&
                <>
                    <FormSectionHeader text='Company Information' icon={<BankOutlined/>} style={{marginTop:48}}
                                       help="All of the information on the company. Only needed if you are inviting a client."/>
                    <Form.Item label='Company Name' name={UsersInviteTypes.CompanyName}
                               rules={[{required: true, message: 'This field is required.'}]}>
                        <Input size='large'/>
                    </Form.Item>
                    <Form.Item label='DUNS Number' name={UsersInviteTypes.DunsNumber}>
                        <Input size='large'/>
                    </Form.Item>
                    <Form.Item label='States' name={UsersInviteTypes.StatesOfBusiness}>
                        <GeographicalStatesSelect/>
                    </Form.Item>
                </>}
            </div>
            {renderButton()}
        </Form>
    );
}

export default UsersInviteForm;